module.exports = __webpack_public_path__ + "static/media/Screen_Shot_6.ca7a653e.png";